import { mode } from "@chakra-ui/theme-tools";
export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: "0.5rem",
        boxShadow: "none",
        transition: ".25s all ease",
        boxSizing: "border-box",
        fontWeight: "500",
        _focus: {
          boxShadow: "none",
        },
        _active: {
          boxShadow: "none",
        },
      },
      variants: {
        outline: () => ({
          borderRadius: "0.5rem",
        }),
        brand: (props) => ({
          bg: mode("brand.500", "brand.500")(props),
          color: "white",
          _focus: {
            bg: mode("brand.500", "brand.500")(props),
          },
          _active: {
            bg: mode("brand.600", "brand.600")(props),
          },
          _hover: {
            bg: mode("brand.600", "brand.400")(props),
          },
        }),
        darkBrand: (props) => ({
          bg: mode("brand.700", "brand.600")(props),
          color: "white",
          _focus: {
            bg: mode("brand.700", "brand.600")(props),
          },
          _active: {
            bg: mode("brand.800", "brand.700")(props),
          },
          _hover: {
            bg: mode("brand.600", "brand.500")(props),
          },
        }),
        lightBrand: (props) => ({
          bg: mode("brand.100", "whiteAlpha.100")(props),
          color: mode("brand.700", "white")(props),
          _focus: {
            bg: mode("brand.100", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("brand.200", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("brand.200", "whiteAlpha.200")(props),
          },
        }),
        light: (props) => ({
          bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
        }),
        action: (props) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("secondaryGray.300", "brand.500")(props),
          color: mode("brand.500", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "brand.500")(props),
          },
          _active: { bg: mode("secondaryGray.300", "brand.600")(props) },
          _hover: {
            bg: mode("secondaryGray.200", "brand.400")(props),
          },
        }),
        setup: (props) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("transparent", "brand.500")(props),
          border: mode("1px solid", "0px solid")(props),
          borderColor: mode("secondaryGray.400", "transparent")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("transparent", "brand.500")(props),
          },
          _active: { bg: mode("transparent", "brand.600")(props) },
          _hover: {
            bg: mode("secondaryGray.100", "brand.400")(props),
          },
        }),
      },
    },
  },
};
